var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestingApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1554,
    height: 1562,
    viewBox: "0 0 1554 1562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.023 1427.22H776.023",
    stroke: "#120909",
    strokeWidth: 40.8189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M486.625 0.0163217C173.816 0.0163217 196.177 -1.41483 146.573 21.7578C78.5991 53.5108 31.3464 109.309 7.62572 185.827L1.10013 206.875L0.295502 769.991C-0.430923 1277.54 -0.0560249 1335.37 4.09994 1356.05C24.433 1457.2 100.425 1534.36 202.194 1557.19C215.914 1560.27 273.202 1561.1 482.846 1561.29C763.113 1561.53 761.139 1561.61 801.362 1547.65C883.505 1519.12 947.452 1445.53 965.319 1358.97C969.64 1338.03 970.286 1253.75 970.442 926.036H928.846C928.699 1257.63 928.082 1339.69 923.684 1356.09C903.085 1432.95 848.165 1489.99 772.493 1513.12L750.946 1519.71L493.809 1520.29C225.896 1520.9 216.624 1520.55 184.069 1508.7C153.019 1497.39 130.222 1482.54 104.29 1456.74C82.7415 1435.3 75.9215 1426.21 65.0218 1404.4C39.2775 1352.88 41.3033 1406.21 41.3033 780.047C41.3033 153.904 39.2823 207.165 65.0065 155.778C75.613 134.591 82.9874 124.629 102.838 104.678C129.342 78.0411 151.52 63.4677 182.608 52.2561C220.135 38.7209 228.748 38.3727 498.118 39.3932C783.147 40.4734 761.996 38.8403 812.715 63.7137C835.789 75.0296 844.032 81.1334 866.022 103.199C888.016 125.269 894.082 133.519 905.294 156.596C919.68 186.207 925.302 185.237 927.565 281.153H969.243C968.814 242.566 968.321 215.094 967.694 211.184C960.536 166.562 936.829 117.423 905.483 82.233C876.004 49.1399 836.249 23.7005 789.731 8.16777L765.311 0.0163217H486.625Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M773.099 545.399V345.629H892.883V367.089H797.29V434.589H883.909V456.049H797.29V545.399H773.099ZM917.562 545.399H892.201L965.554 345.629H990.525L1063.88 545.399H1038.52L978.82 377.233H977.259L917.562 545.399ZM926.926 467.364H1029.15V488.824H926.926V467.364ZM1158.18 482.971H1184.71L1206.95 512.234L1212.8 520.038L1245.97 564.128H1219.44L1197.59 534.865L1192.12 527.451L1158.18 482.971ZM1254.16 445.514C1254.16 466.584 1250.36 484.792 1242.75 500.139C1235.14 515.486 1224.7 527.321 1211.44 535.645C1198.17 543.969 1183.02 548.131 1165.98 548.131C1148.94 548.131 1133.79 543.969 1120.53 535.645C1107.26 527.321 1096.82 515.486 1089.22 500.139C1081.61 484.792 1077.8 466.584 1077.8 445.514C1077.8 424.445 1081.61 406.236 1089.22 390.889C1096.82 375.543 1107.26 363.707 1120.53 355.383C1133.79 347.06 1148.94 342.898 1165.98 342.898C1183.02 342.898 1198.17 347.06 1211.44 355.383C1224.7 363.707 1235.14 375.543 1242.75 390.889C1250.36 406.236 1254.16 424.445 1254.16 445.514ZM1230.75 445.514C1230.75 428.216 1227.86 413.617 1222.07 401.717C1216.35 389.816 1208.58 380.81 1198.76 374.697C1189 368.584 1178.08 365.528 1165.98 365.528C1153.89 365.528 1142.93 368.584 1133.11 374.697C1123.36 380.81 1115.58 389.816 1109.8 401.717C1104.07 413.617 1101.21 428.216 1101.21 445.514C1101.21 462.812 1104.07 477.411 1109.8 489.312C1115.58 501.212 1123.36 510.218 1133.11 516.331C1142.93 522.444 1153.89 525.5 1165.98 525.5C1178.08 525.5 1189 522.444 1198.76 516.331C1208.58 510.218 1216.35 501.212 1222.07 489.312C1227.86 477.411 1230.75 462.812 1230.75 445.514Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1497.21 289.354H621.152C600.144 289.354 583.115 306.383 583.115 327.391V894.829C583.115 915.836 600.144 932.866 621.152 932.866H1497.21C1518.22 932.866 1535.24 915.836 1535.24 894.829V327.391C1535.24 306.383 1518.22 289.354 1497.21 289.354Z",
    stroke: "#120909",
    strokeWidth: 36.9033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1374.5 612.867H659.863C656.975 612.867 654.633 615.209 654.633 618.097V696.113C654.633 699.001 656.975 701.342 659.863 701.342H1374.5C1377.38 701.342 1379.73 699.001 1379.73 696.113V618.097C1379.73 615.209 1377.38 612.867 1374.5 612.867Z",
    stroke: "#120909",
    strokeWidth: 27.8135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M678.239 761.182H1278.24",
    stroke: "#120909",
    strokeWidth: 25.5458,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114.485 1171.68H793.308",
    stroke: "#120909",
    strokeWidth: 33.8608,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M114.485 1235.41H680.171",
    stroke: "#120909",
    strokeWidth: 33.8608,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.485 1107.96H889.474",
    stroke: "#120909",
    strokeWidth: 33.8608,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M302.342 438.604H172.234V557.398H302.342V611.139L429.621 483.86L298.098 382.036L302.342 438.604Z",
    stroke: "#120909",
    strokeWidth: 33.8608,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingApp);
export default __webpack_public_path__ + "static/media/Testing APP.4a05ba77e775ffaa517b2e6c4fb46c22.svg";
export { ForwardRef as ReactComponent };